import { readRuntimeConfig } from "@fox1ck-org/auth";

// The API plants /runtime-config.js (api/src/lib/runtime-config.ts) before any
// module runs: the one camelCase shape, read once here. Vite's dev server has
// no API in front of it, so dev falls back to the prod realm and the same
// public client.
export const runtimeConfig = readRuntimeConfig({
  fallback: import.meta.env.DEV
    ? {
        keycloakIssuer: "https://auth.igrudsky.dev/realms/vibe",
        keycloakClientId: "vibe-platform",
        consoleUrl: "https://console.igrudsky.dev",
        apiBaseUrl: "",
        env: "local",
      }
    : undefined,
});
